import { getTermRange, defineTerm, defineRange, resolveCycleWindow, logWarn, COMPASS } from '@magmacomputing/tempo/plugin-api';
/** definition of meteorological season ranges */
const groups = defineRange([
    // Meteorological (North)
    { key: 'Spring', day: 1, month: 3, symbol: 'Flower', group: 'meteorological', sphere: COMPASS.North },
    { key: 'Summer', day: 1, month: 6, symbol: 'Sun', group: 'meteorological', sphere: COMPASS.North },
    { key: 'Autumn', day: 1, month: 9, symbol: 'Leaf', group: 'meteorological', sphere: COMPASS.North },
    { key: 'Winter', day: 1, month: 12, symbol: 'Snowflake', group: 'meteorological', sphere: COMPASS.North },
    // Meteorological (South)
    { key: 'Spring', day: 1, month: 9, symbol: 'Flower', group: 'meteorological', sphere: COMPASS.South },
    { key: 'Summer', day: 1, month: 12, symbol: 'Sun', group: 'meteorological', sphere: COMPASS.South },
    { key: 'Autumn', day: 1, month: 3, symbol: 'Leaf', group: 'meteorological', sphere: COMPASS.South },
    { key: 'Winter', day: 1, month: 6, symbol: 'Snowflake', group: 'meteorological', sphere: COMPASS.South },
], 'group', 'sphere');
/** resolve the full candidate list for the current context */
function resolve(t, anchor) {
    if (t.sphere === undefined && anchor?.sphere === undefined) {
        logWarn(`[tempo] SeasonTerm requires 'sphere' configuration (e.g. Tempo.init({ sphere: 'north' }) or { sphere: 'south' }).`, t.config);
        return [];
    }
    const list = resolveCycleWindow(t, groups, { anchor, groupBy: ['group', 'sphere'], group: 'meteorological' });
    return list;
}
/**
 * ## SeasonTerm
 * Meteorological season
 */
export const SeasonTerm = defineTerm({
    key: 'szn',
    scope: 'season',
    description: 'Meteorological season',
    groups,
    resolve(anchor) {
        return resolve(this, anchor);
    },
    define(keyOnly, anchor) {
        return getTermRange(this, resolve(this, anchor), keyOnly, anchor);
    }
});
